import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateCurrentType } from "../services/general/actions";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  text: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 0,
  },
}));

function ListItemLink(props) {
  const navigate = useNavigate();

  const handleClick = (event) => {
    // Call the onClick function passed via props, if it exists
    if (props.onClick) {
      props.onClick(event);
    }

    // Call the additionalFunction
    navigate("/response-list");
  };

  return <ListItem button {...props} onClick={handleClick} />;
}
const whichList = (props, classes) => {
  if (props.mainHub) {
    return (
      <List component="nav" aria-label="secondary mailbox folders">
        <h2 className={classes.text}>Afhaalpunt</h2>
        <hr />
        <ListItemLink
          onClick={() => {
            props.updateCurrentType("HubOrders");
          }}
        >
          <ListItemText primary="Bestellingen" />
        </ListItemLink>
        <Divider />
        <ListItemLink
          onClick={() => props.updateCurrentType("HubOrdersSuppliers")}
        >
          <ListItemText primary="Te ontvangen" />
        </ListItemLink>
        <Divider />
        <ListItemLink
          href="response-list"
          onClick={() => props.updateCurrentType("Products")}
        >
          <ListItemText primary="Te ontvangen (Producten)" />
        </ListItemLink>

        <br />
        <h2 className={classes.text}>Boer</h2>
        <hr />

        <ListItemLink
          href="response-list"
          onClick={() => props.updateCurrentType("SuppliersOrders")}
        >
          <ListItemText primary="Te ontvangen" />
        </ListItemLink>
        <Divider />
        <ListItemLink
          href="response-list"
          onClick={() => props.updateCurrentType("Orders")}
        >
          <ListItemText primary="Leveringen" />
        </ListItemLink>
        <Divider />
        <ListItemLink
          href="response-list"
          onClick={() => props.updateCurrentType("HubProducts")}
        >
          <ListItemText primary="Leveringen (Producten)" />
        </ListItemLink>
      </List>
    );
  } else if (props.supplier) {
    return (
      <List component="nav" aria-label="secondary mailbox folders">
        <ListItemLink
          href="response-list"
          onClick={() => props.updateCurrentType("SuppliersOrders")}
        >
          <ListItemText primary="Te ontvangen" />
        </ListItemLink>
        <Divider />
        <ListItemLink
          href="response-list"
          onClick={() => props.updateCurrentType("Orders")}
        >
          <ListItemText primary="Leveringen" />
        </ListItemLink>
        <Divider />
        <ListItemLink
          href="response-list"
          onClick={() => props.updateCurrentType("HubProducts")}
        >
          <ListItemText primary="Leveringen (Producten)" />
        </ListItemLink>
      </List>
    );
  } else if (props.hub) {
    return (
      <List component="nav" aria-label="secondary mailbox folders">
        <ListItemLink
          href="response-list"
          onClick={() => props.updateCurrentType("HubOrders")}
        >
          <ListItemText primary="Bestellingen" />
        </ListItemLink>
        <Divider />
        <ListItemLink
          href="response-list"
          onClick={() => props.updateCurrentType("HubOrdersSuppliers")}
        >
          <ListItemText primary="Te ontvangen" />
        </ListItemLink>
        <Divider />
        <ListItemLink
          href="response-list"
          onClick={() => props.updateCurrentType("Products")}
        >
          <ListItemText primary="Te ontvangen (Producten)" />
        </ListItemLink>
      </List>
    );
  } else {
    return <div></div>;
  }
};

function SimpleList(props) {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div className={classes.root}>{whichList(props, classes, navigate)}</div>
  );
}

function mapStateToProps(state) {
  return {
    currentType: state.general.currentType,
    mainHub: state.login.login_data.mainHub,
    hub: state.login.login_data.hub,
    supplier: state.login.login_data.supplier,
  };
}

export default connect(mapStateToProps, {
  updateCurrentType,
})(SimpleList);
